module.exports = [
	{id: 1, valor: "0 - 1"},
	{id: 11, valor: "1 - 6"},
	{id: 21, valor: "6 - 12"},
	{id: 31, valor: "12 - 15"},
	{id: 41, valor: "15 - 18"},
	{id: 51, valor: "18 - 30"},
	{id: 61, valor: "30 - 60"},
	{id: 71, valor: "+  60"}
]


// WEBPACK FOOTER //
// ./src/components/Catalogs/AgeRanges/index.js